import "core-js/modules/es.string.starts-with.js";
import React from 'react';
import { Link } from 'react-router-dom';
import { DateLabel } from '../../DateLabel';
import { Title, Subtitle, Content, VideoMeta } from '../../Videos/partials';
import { getArticleURL, getArticleRel } from '../../Articles/utils';
import { Podcast } from './../Podcast';
export var PodcastCard = function PodcastCard(_ref) {
  var podcast = _ref.podcast,
    _ref$withTitle = _ref.withTitle,
    withTitle = _ref$withTitle === void 0 ? true : _ref$withTitle,
    _ref$withDate = _ref.withDate,
    withDate = _ref$withDate === void 0 ? false : _ref$withDate,
    withNew = _ref.withNew,
    withPlayIcon = _ref.withPlayIcon,
    _ref$dateFormat = _ref.dateFormat,
    dateFormat = _ref$dateFormat === void 0 ? 'LLL' : _ref$dateFormat;
  var withLink = podcast.body && podcast.alias && podcast.author;
  var url = withLink && getArticleURL(podcast);
  var rel = withLink && getArticleRel(podcast);
  var linkProps = url && url.startsWith('/') ? {
    to: url,
    as: Link,
    'data-fi-event': 'podcast',
    title: podcast.title,
    rel: rel
  } : {
    href: url,
    as: 'a',
    'data-fi-event': 'podcast',
    title: podcast.title,
    rel: rel
  } || {};
  return React.createElement("div", null, React.createElement(Podcast, {
    podcast: podcast,
    withNew: withNew,
    withPlayIcon: withPlayIcon
  }), withTitle && podcast.title ? React.createElement(Content, null, React.createElement(Title, linkProps, podcast.title), podcast.subtitle ? React.createElement(Subtitle, null, podcast.subtitle) : null, podcast.revision.created && withDate ? React.createElement(VideoMeta, null, React.createElement(DateLabel, {
    date: new Date(podcast.revision.created),
    format: dateFormat
  })) : null) : null);
};